<template>
    <div
        class="field"
        :class="[fieldClass, { 'holder-required': !!error }]"
    >
        <label v-if="field.type === 'select'" class="left" :for="inputId">
            {{ displayLabel }}
        </label>

        <div class="middleColumn">
            <select
                v-if="field.type === 'select'"
                :id="inputId"
                :required="field.required"
                :value="value"
                @change="$emit('update:value', $event.target.value)"
            >
                <option value="" disabled>-- Maak een keuze --</option>
                <option
                    v-for="option in field.options"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>

            <textarea
                v-else-if="field.type === 'textarea'"
                :id="inputId"
                :required="field.required"
                :placeholder="displayLabel"
                :aria-label="displayLabel"
                rows="4"
                :value="value"
                @input="$emit('update:value', $event.target.value)"
            />

            <input
                v-else
                :id="inputId"
                :class="inputClass"
                :type="inputType"
                :required="field.required"
                :placeholder="displayLabel"
                :aria-label="displayLabel"
                :value="value"
                @input="$emit('update:value', $event.target.value)"
            />
        </div>

        <p v-if="error" class="message required">{{ error }}</p>
    </div>
</template>

<script>
export default {
    name: "FormField",
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: "",
        },
        error: {
            type: String,
            default: "",
        },
    },
    emits: ["update:value"],
    computed: {
        inputId() {
            return `contact-popup-${this.field.name}`;
        },
        displayLabel() {
            return this.field.required
                ? `${this.field.label}*`
                : this.field.label;
        },
        inputType() {
            if (this.field.type === "email") {
                return "email";
            }

            if (this.field.type === "tel") {
                return "tel";
            }

            return "text";
        },
        inputClass() {
            if (this.field.type === "email") {
                return "email text";
            }

            return "text";
        },
        fieldClass() {
            if (this.field.type === "email") {
                return "email text";
            }

            if (this.field.type === "textarea") {
                return "textarea";
            }

            if (this.field.type === "select") {
                return "dropdown";
            }

            return "text";
        },
    },
};
</script>
